import { Flex } from "@chakra-ui/react";

export default function PublicPageContentContainer(props) {
	return (
		<Flex direction='row' flexGrow='1'>
			<Flex w='100%' direction='column' alignItems='center' bg='white' rounded='0.8em'>
				<Flex w='100%' className="access-page-container" justify='center' alignItems='center' flexGrow='1' >
					<Flex w='100%' justify='center' align='center' minH='inherit'>
						{props.children}
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
}